<template>
    <div class="form-group">
        <label>Salesforce Order IDs</label>
        <ul class="order-list">
            <li
                v-for="(order, index) in orders"
                :key="index"
            >
                <input
                    v-model="order.order_id"
                    type="text"
                    :disabled="!order.enabled"
                />
                <button @click.prevent="removeOrderId(index)">-</button>
            </li>
        </ul>
        <button @click.prevent="addOrderId()">+</button>
    </div>
</template>

<script>
import store from '@/store'

export default {
    props: {
        orders: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        addOrderId() {
            this.$emit('add-order', {
                order_id: null,
                created_by: store.getters.user.id,
                enabled: true,
            })
        },

        removeOrderId(index) {
            this.$emit('remove-order', index)
        },
    },
}
</script>

<style scoped lang="scss">
.order-list {
    li {
        margin-bottom: 5px;
        input {
            display: inline;
            width: 150px;
        }
    }
}
</style>
